import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'
import { Link } from '../../gatsby-helpers'

const NavLink = ({
  classNames,
  children,
  href,
  target,
  onFocus,
  onBlur,
  onMouseEnter,
  onMouseLeave,
  size = 'default',
  invert = false
}) => (
  <Link
    className={cn('NavLink', { [`size-${size}`]: !!size, invert }, classNames)}
    href={href}
    target={target}
    onFocus={onFocus}
    onBlur={onBlur}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    activeClassName="NavLink--active"
  >
    {children}
  </Link>
)

NavLink.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  size: PropTypes.oneOf(['default', 'l']),
  invert: PropTypes.bool
}

export default NavLink
